
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/ubytovanie",
      function () {
        return require("private-next-pages/[region]/[resort]/ubytovanie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/ubytovanie"])
      });
    }
  